'use strict';

import angular from 'angular';

/**
 * Composant pour la barre de navigation
 */
export default angular.module('observatoireApp')
  .component('navbar', {
      templateUrl: 'app/components/navbar/navbar.html',
      controller: 'NavbarController',
      controllerAs: 'vm'
    });
